import _ from 'lodash';
import { METHODS } from 'Shared/paymentMethods';

export default function aggregatorAllowedPaymentMethodsFor(renter, townSupportsCashAndSberbank) {
  return _.filter(METHODS, (method) => {
    const renterAllows = renter[`is_payment_via_${method}_allowed`];

    if (method === METHODS.CASH || method === METHODS.SBERBANK) {
      if (townSupportsCashAndSberbank === false) {
        return false;
      }
      return renterAllows;
    }

    return renterAllows;
  });
}
